module.exports = __webpack_public_path__ + "static/media/3032.dd722f97.jpg";